import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { TextPage } from 'legacyComponents/pages/textPage';

import Header from 'apps/components/header/header';

import CookiesPolicy from 'apps/home/cookies/cookies.md';
import fetchTextDocument from 'utils/fetchTextDocument';

@observer
export class Cookies extends React.Component {
  @observable content = '';

  componentDidMount() {
    fetchTextDocument(CookiesPolicy).then(content => {
      this.content = content;
    });
  }

  render() {
    const __html = this.content;
    return (
      <>
        <Header />
        <TextPage title='Cookies Policy'>
          <div dangerouslySetInnerHTML={{ __html }} />
        </TextPage>
      </>
    );
  }
}
